export const LOCALES = [
  {
    id: 'en',
    name: 'English',
  },
  {
    id: 'es',
    name: 'Español',
  },
  {
    id: 'pt',
    name: 'Português',
  },
];

export const SIGN_UP_TO_POST_URL_FOR_LOCALE = {
  en: '/sign-up-to-post',
  es: '/es/orgs/registrate',
  pt: '/pt/orgs/inscreva-se',
};
